import { render, staticRenderFns } from "./ImageUploadDraggableIds.vue?vue&type=template&id=4a2082a9&scoped=true"
import script from "./ImageUploadDraggableIds.vue?vue&type=script&lang=js"
export * from "./ImageUploadDraggableIds.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadDraggableIds.vue?vue&type=style&index=0&id=4a2082a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2082a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2082a9')) {
      api.createRecord('4a2082a9', component.options)
    } else {
      api.reload('4a2082a9', component.options)
    }
    module.hot.accept("./ImageUploadDraggableIds.vue?vue&type=template&id=4a2082a9&scoped=true", function () {
      api.rerender('4a2082a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/ImageUploadDraggableIds.vue"
export default component.exports